import {
  attachBravaraAttributionClickHandler,
  captureBravaraAttribution
} from '../packages/flow-ui/flow-ui-components/src/utils/bravaraAttribution'

// Attribution is captured on load/route change and only appended to
// bravara.com links at click time. Never rewrite hrefs in the DOM here:
// crawlers render the page and would index the tracking query strings.
export const onClientEntry = () => {
  captureBravaraAttribution()
  attachBravaraAttributionClickHandler()
}

export const onRouteUpdate = () => {
  captureBravaraAttribution()
}
